import { Link } from 'react-router-dom';
import { useState } from 'react';
import { categories } from '@/mocks/data';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [subscribeMsg, setSubscribeMsg] = useState('');

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.currentTarget as HTMLFormElement;
    const honeypot = (form.querySelector('[name="website_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setSubscribeStatus('success');
      setSubscribeMsg('感谢订阅！您将第一时间收到我们的最新内容推送。');
      setEmail('');
      return;
    }
    setSubscribeStatus('loading');
    try {
      const formData = new FormData(form);
      const res = await fetch('https://readdy.ai/api/form/d9pk9odi2vhsdh2d3660', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(text); } catch { /* ignore */ }
      if (res.ok && (parsed as { code?: string })?.code === 'OK') {
        setSubscribeStatus('success');
        setSubscribeMsg('感谢订阅！您将第一时间收到我们的最新内容推送。');
        setEmail('');
      } else {
        const msg = (parsed as { meta?: { message?: string } })?.meta?.message || '订阅失败，请稍后再试';
        setSubscribeStatus('error');
        setSubscribeMsg(msg);
      }
    } catch {
      setSubscribeStatus('error');
      setSubscribeMsg('网络错误，请稍后再试');
    }
  };

  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-bold text-background-50 font-heading">91抖音</span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">记录美好，分享快乐。<br />中国领先的短视频娱乐平台。</p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">内容分类</h4>
            <div className="grid grid-cols-2 gap-2">
              {categories.slice(0, 6).map((cat) => (
                <Link key={cat.slug} to={`/category/${cat.slug}`} className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">关于我们</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">品牌介绍</Link>
              <a href="#" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">加入我们</a>
              <a href="#" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">广告合作</a>
              <a href="#" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">帮助中心</a>
              <a href="#" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">隐私政策</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">订阅最新内容</h4>
            <p className="text-sm text-background-300 mb-3">第一时间获取热门视频和达人动态</p>
            <form onSubmit={handleSubscribe} data-readdy-form="" className="flex flex-col gap-2">
              <input
                type="text"
                name="website_alt"
                className="antispam-field"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
              <div className="flex gap-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入您的邮箱"
                  required
                  className="flex-1 px-3 py-2 text-sm rounded-md bg-background-800 text-background-50 placeholder:text-background-500 border border-background-700 focus:outline-none focus:border-primary-500 transition-colors"
                />
                <button
                  type="submit"
                  disabled={subscribeStatus === 'loading'}
                  className="px-4 py-2 text-sm font-medium whitespace-nowrap cursor-pointer rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors disabled:opacity-60"
                >
                  {subscribeStatus === 'loading' ? '提交中...' : '订阅'}
                </button>
              </div>
              {subscribeStatus !== 'idle' && (
                <p className={`text-xs ${subscribeStatus === 'success' ? 'text-accent-400' : 'text-primary-400'}`}>{subscribeMsg}</p>
              )}
            </form>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">Copyright &copy; 2026 91抖音 All Rights Reserved. | 京ICP备XXXXXXXX号</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">Cookie政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}